import React from 'react'
// import { Box, ButtonGroup, Button } from '@fedsim/components'
// import Demo from './demodata'
// import { ResetAll } from 'pages/settings'
// import { useNavigate } from 'react-router-dom'

// function ImportWWE() {
//   const nav = useNavigate()
//   const onClick = () => nav('/quick-mode/WWE')
//   return (
//     <Button variant="contained" color="success" onClick={onClick}>
//       Import WWE
//     </Button>
//   )
// }
export function Dev() {
  return <></>
  // return (
  //   <Box sx={{
  //     position: 'fixed',
  //     bottom: 0,
  //     right: 0,
  //     zIndex: 1000,
  //     width: '200px',
  //     height: 'auto',
  //   }}>
  //     <ButtonGroup sx={{
  //       flexWrap: 'wrap'
  //     }}>
  //       <ResetAll />
  //       <ImportWWE />
  //       <Demo />
  //     </ButtonGroup>
  //   </Box>
  // )
}

export default Dev
